import React from 'react'
import {HandledErrorPageComponent} from './component'
import {HANDLED_ERROR_BASE_ROUTE} from './constants'
export const routes = [
  {
    action: () => <HandledErrorPageComponent />,
    path: HANDLED_ERROR_BASE_ROUTE,
  },
]
